import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TextSearch icon
 *
 * @category Product
 */
const TextSearch = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          d="M17.5 5H2.5M8.33333 10H2.5M8.33333 15H2.5M17.5001 15.8334L15.9167 14.2501M16.6667 12.5C16.6667 13.8807 15.5474 15 14.1667 15C12.786 15 11.6667 13.8807 11.6667 12.5C11.6667 11.1193 12.786 10 14.1667 10C15.5474 10 16.6667 11.1193 16.6667 12.5Z"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

TextSearch.displayName = 'TextSearch';

export { TextSearch };
